<div class="container">
  <div class="login">
    <img class="logo" src="/assets/logo/login-logo.svg" alt="" />
    <form [formGroup]="logInForm" (ngSubmit)="logInSubmit()">
      <label class="form-label">Username</label>
      <gbui-form-group class="first">
        <gbui-input
          class="inputs"
          simple
          (keyup)="emailToLowercase($event)"
          placeholder="Enter Username"
          formControlName="email"
        ></gbui-input>
      </gbui-form-group>
      <!-- <div class="remember-me-container">
        <input
          [value]="rememberMe"
          (change)="rememberMe = !rememberMe"
          type="checkbox"
        />
        <label for="">Remember me</label>
      </div> -->

      <label class="form-label">Password</label>
      <gbui-form-group>
        <gbui-input
          class="inputs"
          password
          placeholder="Enter your password"
          formControlName="password"
        ></gbui-input>
      </gbui-form-group>
      <label
        class="form-label last"
        [routerLink]="['/authentication/forgot-password']"
        >Forgot Password?</label
      >

      <gbui-animated-height-display [display]="(displaError$ | async)">
        <p gbui-feedback-text="danger">{{ errorMessage$ | async }}</p>
      </gbui-animated-height-display>

      <button
        class="buttons"
        gbui-button
        [disabled]="logInForm.invalid || ((loading$ | async)?? false)"
        context="primary"
        type="submit"
        [busy]="loading$ | async"
      >
        Sign-In
      </button>

      <label class="sing-up-label"
        >Don’t have an account?
        <span [routerLink]="['/authentication/sign-up']"
          >&nbsp;Sign up</span
        ></label
      >
    </form>
  </div>
</div>
